export const dayOptions = [
  {value: 'saturday', label: 'Saturday'},
  {value: 'sunday', label: 'Sunday'},
  {value: 'monday', label: 'Monday'},
  {value: 'tuesday', label: 'Tuesday'},
  {value: 'wednesday', label: 'Wednesday'},
  {value: 'thursday', label: 'Thursday'},
  {value: 'friday', label: 'Friday'},
];

export const timeOptions = Array.from({length: 12}, (_, i) => ({
  value: `${i + 1}:00`,
  label: `${i + 1}:00`,
}));

export const defaultTime = timeOptions[10];

export const amPmOptions = [
  {value: 'AM', label: 'AM'},
  {value: 'PM', label: 'PM'},
];

export const defaultAmPm = amPmOptions[1];

export const durationUnitOptions = [
  {value: 'minutes', label: 'Minutes'},
  {value: 'hours', label: 'Hours'},
  {value: 'days', label: 'Days'},
];

export const defaultUnit = durationUnitOptions[0];
